import script from "./CovidAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./CovidAlert.vue?vue&type=script&setup=true&lang=js"

import "./CovidAlert.vue?vue&type=style&index=0&id=3bb05ba9&lang=scss"

const __exports__ = script;

export default __exports__